import React, { Fragment, useRef } from "react";
import logo from "../../img/logo.png";
import {
  HiBars4,
  HiDocumentText,
  HiHome,
  HiMiniArrowLeftStartOnRectangle,
  HiUserCircle,
  HiUserGroup,
} from "react-icons/hi2";
import { Link, useNavigate } from "react-router-dom";
import { auth } from "../../firebase";
import { useAuth, useUser } from "../../context/contextAPI";
import { Menu, Transition } from "@headlessui/react";
import { toast } from "react-toastify";

function HeaderUser() {
  const { user } = useUser();
  const navigate = useNavigate();
  const { setCurrentUser } = useAuth();
  const drawerToggleRef = useRef(null);

  async function handleLogout() {
    try {
      await auth.signOut();
      setCurrentUser(null);
      toast.success("Votre compte a été déconnecté", {
        position: "top-right",
        autoClose: 1500,
        onClose: () => {
          navigate("/auth/connexion");
        },
      });

      navigate("/auth/connexion");
    } catch (error) {}
  }

  function handleMenuClick() {
    if (drawerToggleRef.current) {
      drawerToggleRef.current.checked = false;
    }
  }

  return (
    <>
      <nav className="fixed top-0 z-50 px-1 sm:px-4 w-full bg-pink-600 border-b border-gray-200">
        <div className="px-3 py-3 lg:px-5 lg:pl-3">
          <div className="flex items-center justify-between">
            <div className="flex items-center justify-start rtl:justify-end">
              <div className="inline-flex items-center text-sm text-white hover:text-gray-300 transition-all duration-300 cursor-pointer rounded-lg sm:hidden focus:outline-none">
                <label htmlFor="drawer" className="drawer-button cursor-pointer">
                  <HiBars4 size={25} />
                </label>
              </div>
              <Link to="/" className="flex ms-2 md:me-24">
                <img src={logo} className="h-11 sm:h-14 me-2" alt="Logo" />
                <span className="self-center text-xl poppins-bold sm:text-4xl whitespace-nowrap text-white">
                  ECOKAZ
                </span>
              </Link>
            </div>
            <div className="flex items-center">
              <Menu as="div" className="relative inline-block text-left">
                <div>
                  <Menu.Button className="inline-flex w-full justify-center rounded-full text-sm text-white hover:bg-black/30 focus:outline-none focus-visible:ring-2 focus-visible:ring-white/75">
                    <HiUserCircle size={40} color="#fff" />
                  </Menu.Button>
                </div>
                <Transition
                  as={Fragment}
                  enter="transition ease-out duration-100"
                  enterFrom="transform opacity-0 scale-95"
                  enterTo="transform opacity-100 scale-100"
                  leave="transition ease-in duration-75"
                  leaveFrom="transform opacity-100 scale-100"
                  leaveTo="transform opacity-0 scale-95"
                >
                  <Menu.Items className="absolute right-0 mt-2 w-56 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black/5 focus:outline-none">
                    {/* <div className="px-3 py-2 hover:bg-pink-500 text-gray-900 hover:text-white transition-all duration-300">
                      <Menu.Item>
                        <Link to="/utilisateur/dashboard" className="flex items-center">
                          <HiHome size={22} />
                          <span className="ms-3">Dashboard</span>
                        </Link>
                      </Menu.Item>
                    </div> */}
                    <div className="px-3 py-2 hover:bg-pink-500 text-gray-900 hover:text-white transition-all duration-300">
                      <Menu.Item>
                        <Link to="/utilisateur/profil" className="flex items-center">
                          <HiUserCircle size={24} />
                          <span className="ms-3">Profil</span>
                        </Link>
                      </Menu.Item>
                    </div>
                    <div className="px-3 py-2 hover:bg-pink-500 text-gray-900 hover:text-white transition-all duration-300">
                      <Menu.Item>
                        <button className="flex items-center" onClick={handleLogout}>
                          <HiMiniArrowLeftStartOnRectangle size={24} />
                          <span className="ms-3">Déconnexion</span>
                        </button>
                      </Menu.Item>
                    </div>
                  </Menu.Items>
                </Transition>
              </Menu>
            </div>
            <input id="drawer" type="checkbox" className="drawer-toggle" ref={drawerToggleRef} />
            <div className="drawer-side">
              <label
                htmlFor="drawer"
                aria-label="close sidebar"
                className="drawer-overlay"
              ></label>
              <ul className="py-2 flex flex-col flex-wrap w-60 min-h-full bg-pink-100 text-base-content space-y-2">
                <Link to="/" className="flex ms-2 md:me-24 my-1">
                  <img src={logo} className="h-12 me-2" alt="Logo" />
                  <span className="self-center text-2xl poppins-bold sm:text-4xl whitespace-nowrap text-gray-900">
                    ECOKAZ
                  </span>
                </Link>
                <hr className="border-gray-900" />
                <div className="px-2 space-y-2 text-sm">
                  {/* <li>
                    <Link
                      to="/utilisateur/dashboard"
                      className="poppins-semibold flex items-center p-2 text-gray-900 rounded-lg hover:bg-pink-500 hover:text-white transition-all duration-300"
                      onClick={handleMenuClick}
                    >
                      <HiHome size={24} />
                      <span className="ms-3">Mon compte</span>
                    </Link>
                  </li> */}
                  {user.roles === "Utilisateur" ? (
                    <>
                    <li>
                      <Link
                        to="/utilisateur/profil"
                        className="poppins-semibold flex items-center p-2 text-gray-900 rounded-lg hover:bg-pink-500 hover:text-white transition-all duration-300"
                        onClick={handleMenuClick}
                      >
                        <HiUserCircle size={24} />
                        <span className="ms-3">Mon profil</span>
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/utilisateur/achats"
                        className="poppins-semibold flex items-center p-2 text-gray-900 rounded-lg hover:bg-pink-500 hover:text-white transition-all duration-300"
                        onClick={handleMenuClick}
                      >
                        <HiDocumentText size={24} />
                        <span className="flex-1 ms-3 whitespace-nowrap">
                          Mes achats
                        </span>
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/utilisateur/parrainage"
                        className="poppins-semibold flex items-center p-2 text-gray-900 rounded-lg hover:bg-pink-500 hover:text-white transition-all duration-300"
                        onClick={handleMenuClick}
                      >
                        <HiUserGroup size={24} />
                        <span className="flex-1 ms-3 whitespace-nowrap">
                          Parrainage
                        </span>
                      </Link>
                    </li>
                    </>
                  ):(
                    <>
                      <li>
                        <Link
                          to="/utilisateur/profil"
                          className="poppins-semibold flex items-center p-2 text-gray-900 rounded-lg hover:bg-pink-500 hover:text-white transition-all duration-300"
                          onClick={handleMenuClick}
                        >
                          <HiUserCircle size={24} />
                          <span className="ms-3">Mon profil</span>
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/utilisateur/liste_utilisateur"
                          className="poppins-semibold flex items-center p-2 text-gray-900 rounded-lg hover:bg-pink-500 hover:text-white transition-all duration-300"
                          onClick={handleMenuClick}
                        >
                          <HiUserCircle size={24} />
                          <span className="ms-3">Liste des utilisateur</span>
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/utilisateur/subscribe"
                          className="poppins-semibold flex items-center p-2 text-gray-900 rounded-lg hover:bg-pink-500 hover:text-white transition-all duration-300"
                          onClick={handleMenuClick}
                        >
                          <HiUserCircle size={24} />
                          <span className="ms-3">S'abonner</span>
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/utilisateur/transactions"
                          className="poppins-semibold flex items-center p-2 text-gray-900 rounded-lg hover:bg-pink-500 hover:text-white transition-all duration-300"
                          onClick={handleMenuClick}
                        >
                          <HiUserCircle size={24} />
                          <span className="ms-3">Transactions</span>
                        </Link>
                      </li>
                    </>
                  )}
                  
                </div>
              </ul>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
}

export default HeaderUser;
